export default __webpack_public_path__ + "static/media/08-field-sync.888617f3.jpg";